"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _VariationAttributes = _interopRequireDefault(require("../../../../shared/components/VariationAttributes/VariationAttributes"));

var _iconFreeGift = _interopRequireDefault(require("../../../../shared/icons/icon-free-gift.svg"));

var _decimalFormatter = _interopRequireDefault(require("../../../../shared/helpers/decimalFormatter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BonusOrderItem = function BonusOrderItemComponent(_ref) {
  var item = _ref.item;
  var productName = item.productName,
      images = item.images,
      variationAttributes = item.variationAttributes,
      price = item.price,
      quantity = item.quantity;
  var basePrice = price.list ? price.list.formatted : price.sales.formatted;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "bonus-order-item__container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bonus-order-item__image"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: images.small[0].url,
    alt: images.small[0].alt
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bonus-order-item__product-details"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bonus-order-item__product-name"
  }, /*#__PURE__*/_react["default"].createElement(_iconFreeGift["default"], {
    className: "bonus-order-item__icon"
  }), productName), /*#__PURE__*/_react["default"].createElement(_VariationAttributes["default"], {
    customClassNamePrefix: "bonus-order-item",
    variationAttributes: variationAttributes
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bonus-order-item__attribute"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "bonus-order-item__attribute-key"
  }, "Item Price"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "bonus-order-item__attribute-value bonus-order-item__attribute-value--light"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "bonus-order-item__product-price-strike"
  }, (0, _decimalFormatter["default"])(basePrice)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "bonus-order-item__product-price-sale"
  }, (0, _decimalFormatter["default"])(price.bonus.formatted), "\xA0with purchase"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bonus-order-item__attribute"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "bonus-order-item__attribute-key"
  }, "Quantity"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "bonus-order-item__attribute-value bonus-order-item__attribute-value--light"
  }, quantity)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bonus-order-line-item__disclaimer"
  }, "This item cannot be returned or exchanged.")));
};

BonusOrderItem.propTypes = {
  item: _propTypes["default"].shape({
    productName: _propTypes["default"].string.isRequired,
    images: _propTypes["default"].shape({
      small: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        url: _propTypes["default"].string.isRequired,
        alt: _propTypes["default"].string.isRequired
      })).isRequired
    }).isRequired,
    variationAttributes: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    price: _propTypes["default"].shape({
      list: _propTypes["default"].shape({
        formatted: _propTypes["default"].string
      }),
      sales: _propTypes["default"].shape({
        formatted: _propTypes["default"].string
      }),
      bonus: _propTypes["default"].shape({
        formatted: _propTypes["default"].string
      })
    }).isRequired,
    quantity: _propTypes["default"].number.isRequired
  }).isRequired
};
var _default = BonusOrderItem;
exports["default"] = _default;